import { Link } from 'react-router-dom'
import '../styles/QuemSomos.css'
import { useCountUp } from '../shared/hooks/useCountUp'

const valores = [
  { letra: 'C', titulo: 'Compromisso',    desc: 'Com cada cliente, entregando soluções que realmente funcionam no dia a dia.' },
  { letra: 'I', titulo: 'Inovação',       desc: 'Sempre em evolução para acompanhar as transformações do mercado.' },
  { letra: 'R', titulo: 'Relacionamento', desc: 'Suporte humano, próximo e dedicado ao sucesso do cliente.' },
  { letra: 'Q', titulo: 'Qualidade',      desc: 'Software testado e validado por centenas de empresas em todo o Brasil.' },
]

const stats = [
  { num: 20,   suffix: '+', label: 'Anos de mercado'   },
  { num: 1500, suffix: '+', label: 'Clientes ativos'   },
  { num: 15,   suffix: '+', label: 'Segmentos'          },
  { num: 9,    suffix: '+', label: 'Estados atendidos'  },
]

function StatItem({ num, suffix, label }: { num: number; suffix: string; label: string }) {
  const { count, ref } = useCountUp(num)
  return (
    <div ref={ref} className="qs-stat-item">
      <div className="qs-stat-num">{count}{suffix}</div>
      <div className="qs-stat-label">{label}</div>
    </div>
  )
}

export default function QuemSomos() {
  return (
    <div className="qs-page">

      {/* ── Hero ── */}
      <section className="qs-hero">
        <div className="qs-hero-grid" />
        <div className="qs-hero-orb">
          <div className="qs-hero-dot" />
        </div>
        <div className="qs-hero-content">
          <div className="qs-hero-eyebrow">Sistema Quantum</div>
          <h1 className="qs-hero-title">
            Quem<br />
            <em>Somos</em>
          </h1>
          <p className="qs-hero-subtitle">
            Conheça a história, a missão e os valores que movem o Sistema Quantum há mais de 20 anos transformando a gestão empresarial em todo o Brasil.
          </p>
          <div className="qs-hero-badge">
            <span>20+</span> anos de tecnologia para empresas de todo o Brasil
          </div>
        </div>
      </section>

      {/* ── Manifesto ── */}
      <section className="qs-manifesto">
        <div className="qs-manifesto-inner">
          <div className="qs-manifesto-tag">Nossa história</div>
          <p className="qs-manifesto-text">
            O <strong>Sistema Quantum</strong> nasceu com o propósito de <em>simplificar</em> a
            gestão empresarial por meio de soluções tecnológicas que acompanham a evolução dos
            negócios brasileiros.
          </p>
          <div className="qs-manifesto-grid">
            <div className="qs-manifesto-col">
              <p>
                Ao longo de mais de 20 anos de história, crescemos junto com nossos clientes,
                compreendendo as particularidades de cada segmento e desenvolvendo soluções que
                atendem às necessidades do comércio varejista e atacadista, das empresas de
                serviços, oficinas mecânicas, lojas de peças e de diferentes outros setores.
              </p>
              <p>
                Mais do que oferecer um sistema de gestão, trabalhamos para tornar o dia a dia das
                empresas mais eficiente, com tecnologia em constante evolução e atendimento
                humanizado, construindo relações de confiança em todo o Brasil.
              </p>
            </div>
            <div className="qs-manifesto-col">
              <p>
                Por trás de cada solução, existe um propósito: apoiar quem empreende, quem abre as
                portas todos os dias, enfrenta desafios, conquista clientes e trabalha para fazer
                seu negócio crescer.
              </p>
              <p>
                Porque acreditamos que quem move a economia merece uma tecnologia que evolua junto
                com seus sonhos e resultados.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="qs-stats">
        <div className="qs-stats-inner">
          {stats.map(({ num, suffix, label }) => (
            <StatItem key={label} num={num} suffix={suffix} label={label} />
          ))}
        </div>
      </section>

      {/* ── Valores ── */}
      <section className="qs-valores">
        <div className="qs-valores-header">
          <div className="qs-section-tag">Nossos valores</div>
          <h2 className="qs-valores-title">
            Princípios que guiam cada decisão
          </h2>
        </div>
        <div className="qs-valores-grid">
          {valores.map(({ letra, titulo, desc }) => (
            <div key={titulo} className="qs-valor-card">
              <div className="qs-valor-letter">{letra}</div>
              <div className="qs-valor-accent" />
              <h3 className="qs-valor-title">{titulo}</h3>
              <p className="qs-valor-desc">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="qs-cta">
        <div className="qs-cta-inner">
          <div className="qs-cta-eyebrow">Próximo passo</div>
          <h2 className="qs-cta-title">
            Vamos crescer juntos?
          </h2>
          <p className="qs-cta-text">
            Agende uma visita e descubra como o Sistema Quantum pode transformar a gestão do seu negócio.
          </p>
          <Link to="/agendar-visita" className="qs-cta-btn">
            Agendar uma Visita
          </Link>
        </div>
      </section>

    </div>
  )
}
